import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Col, Container, Row, Alert, Label } from "reactstrap";
import { Route, Redirect } from "react-router-dom"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { showToast } from '../../UI/ui-toast'
import secureLocalStorage from "react-secure-storage";

// import images
import logoPropertyLight from "../../../assets/images/Property-Appz-White-Logo-v1.png";
import logoPropertyDark from "../../../assets/images/Property-Appz-Logo-v1.0.png";
import CarouselPage from "../child.components/CarouselPage";
import { fetchLogo } from '../../../store/logo/actions';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
const config = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

import constant from '../../../constants.json';
const baseURL = process.env.REACT_APP_API_URL;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      redirect: null,
      logo: '',
    };
    this.t_show.bind(this)
  }
  t_show = () => {
    this.setState(prevState => ({
      show: !prevState.show,
    }))
  }
  async getUserData(user_id) {
    const res = await axios.get(baseURL + "/api/user-assign-permission/" + user_id, config);
    {/* NOTE: This code was originally intended for testing purposes. 
    However, it is causing issues now. 
    If permission to view organization data is not granted to a user, 
    this API returns an error after login. 

    const resOrg = await axios.get(baseURL + "/api/organisation-show", config);
    if (resOrg.status === 200) {
      const orgData = resOrg.data.data
      secureLocalStorage.setItem("orgData", {
        orgData
      });
      console.log(orgData);
    }
  */}
    if (res.status === 200) {
      const data = res.data.data
      secureLocalStorage.setItem("userData", {
        data
      });
      // this.setState({ redirect: "/dashboard" });
      window.location.replace('/');
    }

  }
  componentDidMount() {
    this.props.fetchLogo();
    // Admin-User/Platform-User login flag
    localStorage.removeItem('adminUserLoginFlag');
    // Organisation-User login flag
    localStorage.removeItem('organisationUserLoginFlag');
    localStorage.removeItem('organisation_id');
    localStorage.removeItem('current_project_id');
    localStorage.removeItem('token');
    secureLocalStorage.removeItem("userData");
  }

  redirectToAuthPath() {

  }

  render() {
    const { logoDark } = this.props;
    const { logoWhite } = this.props;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }
    //meta title
    document.title = "Login | PropertyAppz";
    return (
      <React.Fragment>
        <div>
          <Container fluid className="p-0">
            <Row className="g-0">
              <CarouselPage />

              <Col xl={3}>
                <div className="auth-full-page-content p-md-5 p-4">
                  <div className="w-100">
                    <div className="d-flex flex-column h-100">
                      <div className="mb-4 mb-md-5">
                        <Link to="#" className="d-block auth-logo">
                          <img
                            src={logoDark}
                            alt=""
                            height="40"
                            className="auth-logo-dark"
                          />
                          <img
                            src={logoWhite}
                            alt=""
                            height="40"
                            className="auth-logo-light"
                          />
                          {/* <img src={logoUrl} alt="" height="35" /> */}
                        </Link>
                      </div>

                      <div className="my-auto">
                        <div>
                          <h5 className="text-primary">Welcome Back !</h5>
                          <p className="text-muted">
                            Sign in to continue to PropertyAppz.
                          </p>
                        </div>

                        <div className="mt-4">
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              username: (this.state && this.state.username) || secureLocalStorage.getItem('rememberOrgUsername'),
                              password:
                                (this.state && this.state.password) || "",
                            }}
                            validationSchema={Yup.object().shape({
                              username: Yup.string().required(
                                "Please Enter Your Username"
                              ).nullable(),
                              password: Yup.string().required(
                                "Please Enter Valid Password"
                              ),
                            })}
                            onSubmit={values => {
                              var remCheck = document.getElementById('remember-check').checked;
                              axios.post(baseURL + "/api/login", {

                                "email": values.username,
                                "password": values.password
                              }, config)
                                .then((response) => {
                                  if (remCheck) {
                                    secureLocalStorage.setItem('rememberOrgUsername', values.username)
                                  }
                                  showToast("Success", "Hurray! Let's proceed to great things.", "success");
                                  // Organisation-User Login Flag
                                  localStorage.setItem("organisationUserLoginFlag", true);
                                  localStorage.setItem("organisation_id", response.data.data.user.organisation_id);
                                  let token = response.data.data.token;
                                  let personalData = response.data.data.user;
                                  localStorage.setItem("token", 'Bearer ' + token);
                                  secureLocalStorage.setItem("personalData", { personalData });
                                  secureLocalStorage.setItem("headerOrganisationUserData", personalData);
                                  config.headers.Authorization = 'Bearer ' + token;
                                  this.getUserData(response.data.data.user.id)
                                  //window.location.replace('/dashboard');

                                })
                                .catch((error) => {
                                  showToast("Failed", error.response.data.message, "error");
                                });

                            }}
                          >
                            {({ errors, status, touched }) => (
                              <Form className="form-horizontal">
                                {this.props.error && this.props.error ? (
                                  <Alert color="danger">
                                    {this.props.error}
                                  </Alert>
                                ) : null}

                                <div className="mb-3">
                                  <Label for="username" className="form-label">
                                    Username
                                  </Label>
                                  <Field
                                    name="username"
                                    placeholder="Enter username"
                                    type="username"
                                    className={
                                      "form-control" +
                                      (errors.username && touched.username
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name="username"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mb-3">
                                  <Label for="password" className="form-label">
                                    Password
                                  </Label>
                                  <div className="input-group auth-pass-inputgroup">
                                    <Field
                                      name="password"
                                      placeholder="Enter Password"
                                      type={this.state.show ? "text" : "password"}
                                      autoComplete="true"
                                      className={
                                        "form-control" +
                                        (errors.password && touched.password
                                          ? " is-invalid"
                                          : "")
                                      }
                                    />
                                    <button onClick={this.t_show} className="btn btn-light " type="button" id="password-addon">
                                      <i className="mdi mdi-eye-outline"></i></button>
                                    <ErrorMessage
                                      name="password"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="remember-check"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="remember-check"
                                  >
                                    Remember me
                                  </label>
                                </div>

                                <div className="mt-3 d-grid">
                                  <button
                                    className="btn btn-primary btn-block"
                                    type="submit"
                                  >
                                    {" "}
                                    Log In{" "}
                                  </button>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>

                      <div className="mt-4 mt-md-5 text-center">
                        <p className="mb-0">
                          © {new Date().getFullYear()} <a href='https://propertyappz.com/' target='_blank' rel="noreferrer">Property Appz</a> + <a href='https://pentadmedia.com/' target='_blank' rel="noreferrer">Pentad Media</a>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  error: PropTypes.any,
  fetchLogo: PropTypes.func,
  logoUrl: PropTypes.shape({
    logo: PropTypes.string,
    icon: PropTypes.string,
    white_logo: PropTypes.string
  })
};

const mapStateToProps = (state) => {
  return {
    logoDark: state.Logo.logo.logoUrl?.logo,
    logoWhite: state.Logo.logo.logoUrl?.white_logo,
  };
};

export default connect(mapStateToProps, { fetchLogo })(withTranslation()(Login));
